// extracted by mini-css-extract-plugin
export var button = "_ih-2";
export var card = "_ih-0";
export var closeButtonContainer = "_ih-3";
export var iconContainer = "_ih-1";